function formatExternalMatches(data, dayInFuture = null) {
  // group matches by date
  const groupedByDate = {};
  let receivedDayId = null;
  let receivedDateHasMatch = false;
  if (dayInFuture !== null) {
    if (dayInFuture === 0) {
      receivedDayId = 'today';
    } else if (dayInFuture < 0) {
      const pastDays = Math.abs(dayInFuture);
      receivedDayId = `past-${pastDays}`;
    } else {
      receivedDayId = `future-${dayInFuture}`;
    }
  }

  data.forEach((match) => {
    const matchDate = new Date(match.start);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let dateId, dateName, dateDesc;
    const daysDiff = Math.floor((matchDate - today) / (1000 * 60 * 60 * 24));

    if (daysDiff === 0) {
      dateId = 'today';
      dateName = "Aujourd'hui";
    } else if (daysDiff < 0) {
      const pastDays = Math.abs(daysDiff);
      dateId = `past-${pastDays}`;
      dateName = [
        'Dimanche',
        'Lundi',
        'Mardi',
        'Mercredi',
        'Jeudi',
        'Vendredi',
        'Samedi'
      ][matchDate.getDay()];
    } else {
      dateId = `future-${daysDiff}`;
      dateName = [
        'Dimanche',
        'Lundi',
        'Mardi',
        'Mercredi',
        'Jeudi',
        'Vendredi',
        'Samedi'
      ][matchDate.getDay()];
    }
    if (dateId == receivedDayId) receivedDateHasMatch = true;

    dateDesc =
      matchDate.getDate() +
      ' ' +
      [
        'janv',
        'févr',
        'mars',
        'avr',
        'mai',
        'juin',
        'juil',
        'août',
        'sept',
        'oct',
        'nov',
        'déc'
      ][matchDate.getMonth()];

    if (!groupedByDate[dateId]) {
      groupedByDate[dateId] = {
        id: dateId,
        dateName,
        dateDesc,
        dayMatches: {}
      };
    }

    // extract league info from league string
    const leagueParts = match.league.split('.');
    let country = leagueParts[0];
    let leagueName = leagueParts.slice(1).join('.').trim();

    if (!leagueName) {
      leagueName = match.league;
      country = '';
    }

    // create category id from league
    const categoryId = leagueName.toLowerCase().replace(/[^a-z0-9]/g, '');

    if (!groupedByDate[dateId].dayMatches[categoryId]) {
      groupedByDate[dateId].dayMatches[categoryId] = {
        category: {
          id: categoryId,
          name: leagueName,
          logo: `/images/leagues/${categoryId}.png`,
          round: 'Match'
        },
        matches: []
      };
    }

    // extract all quotes from odds, organized by type
    const quotes = {};
    const allOdds = {};

    match.odds.forEach((odd) => {
      // basic 1X2 quotes
      if (odd.type === 1) quotes['1'] = odd.value.toString();
      if (odd.type === 2) quotes['2'] = odd.value.toString();
      if (odd.type === 3) quotes['X'] = odd.value.toString();

      // store all odds with more detailed information
      allOdds[odd.type] = {
        value: odd.value,
        description: odd.description,
        group: odd.group,
        probability: odd.probability
      };
    });

    // create formatted match with all available information
    const formattedMatch = {
      id:
        match.id ||
        `match-${dateId}-${categoryId}-${Math.random()
          .toString(36)
          .substr(2, 9)}`,
      time: matchDate.toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      }),
      date: match.start,
      league: match.league,
      location: match.location,
      durationMin: match.durationMin,
      team1: {
        id: match.teams.home.toLowerCase().replace(/[^a-z0-9]/g, ''),
        name: match.teams.home,
        logo: match.logo.home,
        score: match.score.home
      },
      team2: {
        id: match.teams.away.toLowerCase().replace(/[^a-z0-9]/g, ''),
        name: match.teams.away,
        logo: match.logo.away,
        score: match.score.away
      },
      isFinished: false,
      // basic quotes for compatibility
      quotes: Object.keys(quotes).length > 0 ? quotes : null,
      // all detailed odds for advanced features
      allOdds: allOdds,
      // additional metadata
      metadata: {
        totalOddsCount: match.odds.length,
        hasLocation: !!match.location,
        duration: match.durationMin,
        country: country,
        category: leagueName
      }
    };

    groupedByDate[dateId].dayMatches[categoryId].matches.push(formattedMatch);
  });

  // convert dayMatches object to array and sort by date
  console.log(
    '🚀 ~ formatExternalMatches ~ receivedDateHasMatch:',
    receivedDateHasMatch
  );
  console.log('🚀 ~ formatExternalMatches ~ receivedDayId:', receivedDayId);
  if (!receivedDateHasMatch && dayInFuture !== null) {
    groupedByDate[receivedDayId] = {
      id: receivedDayId,
      dayMatches: {}
    };
  }
  return Object.values(groupedByDate).map((dateGroup) => {
    const dayMatchesArray = Object.values(dateGroup.dayMatches);
    const totalMatches = dayMatchesArray.reduce(
      (sum, category) => sum + category.matches.length,
      0
    );
    return {
      ...dateGroup,
      dayMatches: dayMatchesArray,
      totalMatches
    };
  });
  // .sort((a, b) => {
  //   const aDate = new Date(a.dateDesc + ' 2025');
  //   const bDate = new Date(b.dateDesc + ' 2025');
  //   return aDate - bDate;
  // });
}

// const formated = formatExternalMatches(externalMatches)

export default formatExternalMatches;
